import styled from 'styled-components';
import InputSkeleton from '../../inputs/components/input-skeleton';

export const InputSkeletonSC = styled(InputSkeleton)`
  :hover {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'text')};
  }
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)} !important;
  color: ${({ theme }) => theme.color.tint.tertiary};
  ${({ theme }) => theme.mappedTypography.body2.strong};

  .input-separator {
    padding: 0 12px;
    pointer-events: none;
  }
`;

export const InputSC = styled.input`
  flex: 1;
  margin: 0;
  padding: 0;
  min-height: 100%;
  width: 100%;
  z-index: 1;
  transition: all 0.2s;

  border: none;
  background: none;
  outline: none;
  box-shadow: none;

  ${({ theme }) => theme.mappedTypography.body2.strong};

  color: ${({ theme }) => theme.color.tint.primary};
  :focus {
    color: ${({ theme }) => theme.color.tint.selection};
  }
  :placeholder {
    color: ${({ theme }) => theme.color.tint.tertiary};
  }

  .on-dark & {
    color: ${({ theme }) => theme.color.tint.primaryDark};
    :focus {
      color: ${({ theme }) => theme.color.tint.selection};
    }
    ::placeholder {
      color: ${({ theme }) => theme.color.tint.tertiaryDark};
    }
  }

  :disabled,
  :read-only {
    cursor: not-allowed;
  }
`;
